import type { ComponentProps } from "react";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { tv } from "tailwind-variants";

const markdownContentVariants = tv({
  base: [
    "[&_strong]:font-semibold",
    "[&_ul]:list-inside [&_ul]:list-disc [&_ul]:pl-1.5",
    "[&_em]:not-italic",
    "[&_span]:text-secondary-500",
    "[&_a]:underline",
  ],
});

const markdownContentClassName = markdownContentVariants();

export const MarkdownContent = ({
  ...props
}: ComponentProps<typeof Markdown>) => {
  return (
    <div className={markdownContentClassName}>
      <Markdown
        remarkPlugins={[remarkGfm]}
        components={{
          code: "span",
          a: ({ node: _node, children, ...props }) => (
            <a {...props} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          ),
        }}
        {...props}
      />
    </div>
  );
};
